import { Dialog } from "@headlessui/react"
import { KTitleSpan, KSpan, KButton, KDropdown, KTooltip } from "kahuna-base-react-components"
import React, { useEffect, useState } from "react"
import { lang } from "../../../../../constants/languages"

const UserSummaryModal = ({
  linkList,
  setLinkList
}: {
  linkList?: string[]
  setLinkList: (linkList?: string[]) => void
}) => {
  return (
    <Dialog open={linkList !== undefined} onClose={() => setLinkList(undefined)}>
      <div className="fixed w-screen h-screen top-0 left-0 z-250 flex items-center justify-center bg-[#0000004d] ">
        <div className="p-6 shadow-md w-[360px] rounded-[10px] bg-[#fff]">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-6 items-center justify-center">
              <span
                className="w-[72px] aspect-square rounded-full flex justify-center items-center"
                style={{
                  border: "1px solid #F3F3F3"
                }}
              >
                <img className="w-8 h-8" src="/account_icons/music-note-sparkle-filled.svg" />
              </span>
              <KTitleSpan
                text={lang.reports.list_component.click_to_download}
                fontSize={20}
                lineHeight="28px"
                color="#000"
              />
            </div>
            <div className="flex flex-col gap-2 mt-4">
              {linkList?.map((link, index) => {
                const linkSplited = link.split("/")
                return (
                  <div key={`${index}_link_royalty_report`}>
                    <KButton
                      text={linkSplited[linkSplited.length - 1]}
                      onClick={() => window.open(link, "_blank")}
                      shadowDisabled={true}
                      background="transparent"
                    />
                  </div>
                )
              })}
            </div>
            <div className="mt-4 justify-end flex">
              <KButton text={lang.common.close} onClick={() => setLinkList(undefined)} background="transparent" />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default UserSummaryModal
